import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSnackbar,{attrs:{"color":_vm.status,"bottom":"","right":""},model:{value:(_setup.isVisible),callback:function ($$v) {_setup.isVisible=$$v},expression:"isVisible"}},_vm._l((_vm.textArray),function(text){return _c('div',{key:text},[_vm._v("\n    "+_vm._s(text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }